import { render, staticRenderFns } from "./TariffContent2.vue?vue&type=template&id=13d0c990&scoped=true"
import script from "./TariffContent2.vue?vue&type=script&lang=js"
export * from "./TariffContent2.vue?vue&type=script&lang=js"
import style0 from "./TariffContent2.vue?vue&type=style&index=0&id=13d0c990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0c990",
  null
  
)

export default component.exports